/* istanbul ignore file */

import i18n from "i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from "react-i18next";

import translationDE from './translations/de/translation.json'; //German
import translationEN from './translations/en/translation.json'; //English
import translationFR from './translations/fr/translation.json'; //French
import translationBR from './translations/pt/translation.json'; //Portugese
import translationCN from './translations/zh/translation.json'; //Chinese

// translations
const resources = {
  en: {
    translation: translationEN
  },
  de: {
    translation: translationDE
  },
  fr: {
    translation: translationFR
  },
  zh: {
    translation: translationCN
  },
  pt: {
    translation: translationBR
  }
};

i18n
  .use(LanguageDetector) // detect user language
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en",
    fallbackLng: "en", // use en if detected lng is not available

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react is already safe from xss
    }
  });

export const getI18NMessage = str => i18n.t(str);

export default i18n;
